import React, { useState } from 'react';
import apiClient from '../services/apiClient';

// Mirrors the admin Create User feature, but scoped to franchise accounts — they can
// only create Delivery Partner logins for their own team (role is fixed, not selectable).
const FranchiseCreateUser = ({ franchiseId }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage('');
    const token = localStorage.getItem('token');
    try {
      await apiClient.post('/franchise/create-delivery-partner', { name, email, password, phone, franchiseId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage('Delivery partner created successfully!');
      setName('');
      setEmail('');
      setPassword('');
      setPhone('');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to create delivery partner.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4 md:p-6 bg-white shadow-md rounded-lg">
      <div className="flex items-center justify-center gap-3 mb-6">
        <div className="h-8 w-2 bg-green-500 rounded-full"></div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight text-center">Add Delivery Partner</h2>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full Name" className="w-full p-2 border rounded-md" required />
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full p-2 border rounded-md" required />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full p-2 border rounded-md" required />
        <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone Number" className="w-full p-2 border rounded-md" required />
        <div className="w-full p-2 border rounded-md bg-gray-50 text-gray-500">Role: Delivery Partner</div>
        <div className="flex justify-center mt-6">
          <button type="submit" disabled={submitting} className="w-full md:w-auto px-12 py-3 bg-blue-600 text-white rounded-lg font-bold shadow-md hover:bg-blue-700 hover:shadow-lg transition-all disabled:opacity-60">
            {submitting ? 'Creating...' : 'Create Account'}
          </button>
        </div>
      </form>
      {message && <p className="mt-4 text-center text-sm">{message}</p>}
    </div>
  );
};

export default FranchiseCreateUser;
